import * as React from 'react';
import { Component } from 'react';
import { injectGlobal } from 'emotion';
import styled, { css } from 'react-emotion';
import get from 'lodash/get';
import { SearchCtxProvider } from '../Search/SearchContext';
import Fonts from '@emcm-ui/component-theme/lib/styles/Fonts.css';
const Wrapper = styled('div') `
  display: flex;
  max-width: 100vw;
  min-height: 100%;
  ${p => !p.theme.isHomePage() &&
    css `
      padding-top: var(--colorbar-height);
      &:before {
        background: ${p.theme.docz.colors.primary};
        content: '';
        left: 0;
        height: var(--colorbar-height);
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 3;
      }
    `};
`;
const base = (body) => injectGlobal `
    :root {
      --colorbar-height: calc(30rem / 16);
      --sidebar-width: 260px;
      --sidebar-padding: 20px;
    }
    html {
      font-size: 16px;
    }
    body {
      ${body};
    }
    ${Fonts};
  `;
export class Main extends Component {
    componentDidUpdate(prevProps) {
        const body = this.getBody(this.props);
        const prevBody = this.getBody(prevProps);
        if (body && prevBody !== body)
            base(body);
    }
    componentDidMount() {
        base(this.getBody(this.props));
    }
    render() {
        return (React.createElement(SearchCtxProvider, { menuConfig: this.props.config.menu },
            React.createElement(Wrapper, null, this.props.children)));
    }
    getBody(props) {
        return get(props, 'config.themeConfig.styles.body');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy9zaGFyZWQvTWFpbi9pbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUE7QUFDOUIsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLE9BQU8sQ0FBQTtBQUNqQyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBQ3RDLE9BQU8sTUFBTSxFQUFFLEVBQUUsR0FBRyxFQUFFLE1BQU0sZUFBZSxDQUFBO0FBQzNDLE9BQU8sR0FBRyxNQUFNLFlBQVksQ0FBQTtBQUM1QixPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSx5QkFBeUIsQ0FBQTtBQUMzRCxPQUFPLEtBQUssTUFBTSwrQ0FBK0MsQ0FBQTtBQUVqRSxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLENBQUE7Ozs7SUFJekIsQ0FBQyxDQUFDLEVBQUUsQ0FDSixDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBVSxFQUFFO0lBQ3JCLEdBQUcsQ0FBQTs7O3NCQUdlLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxPQUFPOzs7Ozs7Ozs7S0FTNUM7Q0FDSixDQUFBO0FBTUQsTUFBTSxJQUFJLEdBQUcsQ0FBQyxJQUFTLEVBQUUsRUFBRSxDQUN6QixZQUFZLENBQUE7Ozs7Ozs7Ozs7UUFVTixJQUFJOztNQUVOLEtBQUs7R0FDUixDQUFBO0FBRUgsTUFBTSxPQUFPLElBQUssU0FBUSxTQUFvQjtJQUNyQyxrQkFBa0IsQ0FBQyxTQUFvQjtRQUM1QyxNQUFNLElBQUksR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQTtRQUNyQyxNQUFNLFFBQVEsR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFDLFNBQVMsQ0FBQyxDQUFBO1FBRXhDLElBQUksSUFBSSxJQUFJLFFBQVEsS0FBSyxJQUFJO1lBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQzNDLENBQUM7SUFFTSxpQkFBaUI7UUFDdEIsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUE7SUFDaEMsQ0FBQztJQUVNLE1BQU07UUFDWCxPQUFPLENBQ0wsb0JBQUMsaUJBQWlCLElBQUMsVUFBVSxFQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLElBQUk7WUFDbkQsb0JBQUMsT0FBTyxRQUFFLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxDQUFXLENBQ3RCLENBQ3JCLENBQUE7SUFDSCxDQUFDO0lBRU8sT0FBTyxDQUFDLEtBQWdCO1FBQzlCLE9BQU8sR0FBRyxDQUFDLEtBQUssRUFBRSxnQ0FBZ0MsQ0FBQyxDQUFBO0lBQ3JELENBQUM7Q0FDRiJ9